// plugins used for both question & reply content
export const EDITOR_PLUGINS = { link: true, equation: true, image: true, video: true };
// Who writes questions and replies with ADMIN_EDITOR_PLUGINS.
export const ADVANCED_EDITOR_ROLES = [
  'admin',
  'instructor',
  'ss_instructor',
  'mcat_instructor',
  'lsat_instructor',
  'dat_instructor',
  'sat_instructor',
  'act_instructor',
];
export const ADMIN_EDITOR_PLUGINS = {
  ...EDITOR_PLUGINS,
  alignment: true,
  colors: true,
  copyPaste: true,
  inlineStyles: true,
  listTypes: true,
  rawLatexInput: true,
  supSub: true,
};

// Reply text is 16px and h3 the one heading size above it, so every heading in AI-written Markdown becomes h3.
export const REPLY_HEADING_TYPE = 'header-three';
